import { useState } from "react";
import { faqList } from "@/mocks/chigua";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqList.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5 lg:gap-14">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
              <i className="ri-questionnaire-line" aria-hidden="true"></i>
              常见问题
            </span>
            <h2 className="mt-4 font-heading text-2xl text-foreground-950 md:text-4xl">关于吃瓜入口，你可能想问</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              汇总了大家最常关心的问题。如果这里没找到答案，欢迎通过页脚的联系方式与我们联系，我们会尽快答复。
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col gap-3">
              {faqList.map((f, i) => {
                const isOpen = openIdx === i;
                return (
                  <div key={f.q} className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50">
                    <button
                      type="button"
                      onClick={() => setOpenIdx(isOpen ? -1 : i)}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                      aria-expanded={isOpen}
                    >
                      <h3 className="flex items-center gap-3 text-sm font-medium text-foreground-900 md:text-base">
                        <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-semibold text-primary-600">
                          {i + 1}
                        </span>
                        {f.q}
                      </h3>
                      <i className={`shrink-0 text-xl text-foreground-400 transition-transform ${isOpen ? "rotate-180 text-primary-500" : ""} ri-arrow-down-s-line`} aria-hidden="true"></i>
                    </button>
                    <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 pl-14 text-sm leading-relaxed text-foreground-600">{f.a}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}